import React from "react";
import "react-image-gallery/styles/css/image-gallery.css";
import { getLiveStream } from "../../../store/social/social.selector";
import { useDispatch, useSelector } from "react-redux";
import { getImage } from "../../../store/user/user.selector";
import { getCartProductList } from "../../../store/shopping/shopping.selector";
import { getProductByIDSRequest, getCartRequest } from "../../../store/shopping/shopping.actions";
import { useEffect } from "react";
import ProductDetail from "../../MyStore/ProductCart";

const Product = (props) => {
    const dispatch = useDispatch();
    const { livestream, products, cart } = useSelector((state) => {
        return {
            livestream: getLiveStream(state),
            products: getCartProductList(state),
            cart: state.ShoppingReducer.cart
        };
    });

    useEffect(() => {
        dispatch(getCartRequest())
    }, [])

    useEffect(() => {
        if (livestream._id) {
            dispatch(
                getProductByIDSRequest({
                    products: livestream.products.map((x) => x.id),
                })
            );
        }
    }, [livestream]);

    return (
        <div
            className={`${props.onlyProduct
                ? "h-[calc(100vh_-_125px)]"
                : "h-[calc(100vh_-_175px)]"
                } overflow-y-auto`}
        >
            <div className="flex items-center justify-start mx-1 mt-4 mb-6">
                <img
                    src={getImage(livestream.owner.attachments)}
                    alt=""
                    className="rounded-full w-[35px] aspect-square mr-2.5"
                />
                <div className="">
                    <h4 className="text-sm font-medium text-ebony-color capitalize">
                        {livestream.owner.fullName}
                    </h4>
                    <p className="text-[10px] text-black-50">
                        @{livestream.owner.userName}
                    </p>
                </div>
            </div>
            <div className="">
                {products &&
                    products.map((product) => {
                        return (
                            <ProductDetail cart={cart} livestream={livestream} product={product} />
                        );
                    })}
            </div>
        </div>
    );
};

export default Product;
